import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectLabels } from 'selectors/labels/base'
import { selectTicketSearchTotalCountsByQueryId } from 'selectors/search'

import { sortByKeyTypeDesc } from 'util/arrays'

import Item from './Item'

const Tags = props => {
  const {
    buildMailboxFolderPath,
    buildMailboxQueryString,
    doOpenSearchPage,
    doStartSearchTimer,
    isSubMenuItem,
  } = props
  const labelsRaw = useSelector(selectLabels)
  const ticketCounts = useSelector(selectTicketSearchTotalCountsByQueryId)

  const labels = useMemo(
    () => {
      return labelsRaw
        .map(label => {
          // We use the ticketCount in two places, so
          // build a new object with that property
          const ticketCount =
            ticketCounts[
              buildMailboxQueryString({
                state: 'opened',
                label: label.id,
              })
            ]
          return { ...label, ticketCount }
        })
        .filter(label => label.ticketCount > 0)
        .sort(sortByKeyTypeDesc('ticketCount', 'number'))
        .map(label => {
          return {
            id: label.id,
            name: label.name,
            ticketCount: label.ticketCount,
          }
        })
    },
    [ticketCounts, buildMailboxQueryString, labelsRaw]
  )

  if (!labels) return null
  return labels.map(label => {
    return (
      <Item
        labelId={label.id}
        name={label.name}
        key={`label-${label.id}`}
        doOpenSearchPage={doOpenSearchPage}
        doStartSearchTimer={doStartSearchTimer}
        className="label"
        displayCountWhenInactive
        ticketCount={label.ticketCount}
        buildMailboxFolderPath={buildMailboxFolderPath}
        buildMailboxQueryString={buildMailboxQueryString}
        isSubMenuItem={isSubMenuItem}
      />
    )
  })
}

export default Tags
